import { Typography } from 'core/common/ui/ui-kit';
import { PaymentContent } from 'core/flow/entities/Content';
import { Locales } from 'core/user/entities';
import { Location, LocationOption } from 'core/user/ui';

export const CardPaymentDisclaimer = ({ content }: { content: PaymentContent }) => {
  return (
    <Location>
      <LocationOption option={Locales.BR}>
        <Typography align="center" variant="bodySmallRegular">
          {content.cardPaymentDisclaimer}
        </Typography>
      </LocationOption>
    </Location>
  );
};
